import styles from './ProcessMap.module.css';

type EdgeDeleteButtonProps = {
  x: number;
  y: number;
  onDelete: () => void;
};

export const EdgeDeleteButton = ({ x, y, onDelete }: EdgeDeleteButtonProps) => {
  return (
    <foreignObject x={x} y={y} width={25} height={25}>
      <button
        onClick={e => {
          e.stopPropagation();
          onDelete();
        }}
        className={styles.edgeDeleteButton}
      >
        x
      </button>
    </foreignObject>
  );
};
